import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'
import App from './App';
import './index.css';
import { ConfigProvider } from './hooks/useConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <ConfigProvider>
            <App />
        </ConfigProvider>
    </BrowserRouter>
)